var map = {
	"./b_b.png": 97,
	"./b_w.png": 98,
	"./bg.png": 99,
	"./k_b.png": 100,
	"./k_w.png": 101,
	"./n_b.png": 102,
	"./n_w.png": 103,
	"./p_b.png": 104,
	"./p_w.png": 105,
	"./q_b.png": 106,
	"./q_w.png": 107,
	"./r_b.png": 108,
	"./r_w.png": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;